export default __webpack_public_path__ + "static/media/image.09d7af5f.png";